// @ts-nocheck
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 2,
    },
    /* Store Custom Code - Start */
    geolocation: {
        defaultLat: 41.757502,
        defaultLong: -71.44552,
    },
    googleMapsLibraries: ["places"],
    coolCalcStylesheets: [
        "https://unpkg.com/leaflet@1.6.0/dist/leaflet.css",
        "https://unpkg.com/@geoman-io/leaflet-geoman-free@latest/dist/leaflet-geoman.css", // 2.15.0
        "https://cdn.coolcalc.com/leaflet-measure-path/leaflet-measure-path.css",
        "https://fonts.googleapis.com/css?family=Poppins:300,400,500,700,900&amp;display=swap",
        "https://use.fontawesome.com/releases/v5.11.2/css/all.css",
        "https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/css/bootstrap.min.css",
        "https://cdn.coolcalc.com/css/mj8/v-bootstrap/current/restui.css",
        "https://cdn.coolcalc.com/css/mj8/v-bootstrap/current/print.css",
    ],
    coolCalcFirstPassScripts: [
        "https://code.jquery.com/jquery-3.4.1.min.js",
        "https://www.gstatic.com/charts/loader.js",
        "https://unpkg.com/leaflet@1.9.0/dist/leaflet.js",
        "https://unpkg.com/leaflet.gridlayer.googlemutant@latest/dist/Leaflet.GoogleMutant.js", // 0.14.0
        "https://unpkg.com/@geoman-io/leaflet-geoman-free@latest/dist/leaflet-geoman.min.js", // 2.15.0
        "https://cdn.coolcalc.com/leaflet-measure-path/leaflet-measure-path.js",
        "https://cdn.jsdelivr.net/npm/popper.js@1.16.0/dist/umd/popper.min.js",
        "https://cdn.coolcalc.com/khipu-js/current/khipu.js",
        "https://cdn.coolcalc.com/javascript/mj8/shared/current/mj8.js",
        // "/dist/khipu.js", // Use commented ressources when developing locally without https certificate and port
        // "/dist/mj8.js", // Use commented ressources when developing locally without https certificate and port
    ],
    coolCalcSecondPassScripts: [
        "https://stackpath.bootstrapcdn.com/bootstrap/4.4.1/js/bootstrap.min.js",
        "https://code.jquery.com/ui/1.12.1/jquery-ui.min.js",
        "https://cdn.coolcalc.com/javascript/map-trace/current/mt-widget.js",
        // "/dist/mt-widget.js", // Use commented ressources when developing locally without https certificate and port
        "https://cdn.coolcalc.com/javascript/mj8/v-bootstrap/current/tools.js",
        "https://cdn.coolcalc.com/khipu-callbacks/mj8/v-bootstrap/current/khipu-callbacks.js",
    ],
    widgetGroup: {
        partFinder: "Part Finder" as any,
    },
    availability: {
        notAvailable: "NotAvailable",
    },
    /* Store Custom Code - End */
});
